import React, {CSSProperties, FunctionComponent, useEffect} from "react";
import OurModal from "../OurModal/OurModal";
import {OurModalProps} from "../OurModal/OurModalTypes";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import "../../style/Modal.scss";
import "./OurPaperModal.scss";
import IconButton from "@material-ui/core/IconButton";
import {CloseTooltip} from "../../style/MaterialUIStyling";

export type PaperModalProps = OurModalProps & {
  overrideModalStyle?: CSSProperties,
  overrideCloseIconStyle?: CSSProperties,
  overrideLeftSideElementStyle?: CSSProperties,
  overrideNavBarStyle?: CSSProperties,
  disableClose?: boolean,
  leftSideElement?: JSX.Element,
}

const OurPaperModal: FunctionComponent<PaperModalProps> = (commissionModalProps) => {
  const {
    children,
    disableClose,
    leftSideElement,
    overrideCloseIconStyle,
    overrideModalStyle,
    overrideLeftSideElementStyle,
    overrideNavBarStyle,
    parentToggle,
    setParentClose,
  } = commissionModalProps;

  useEffect(() => {

  }, []);

  useEffect(() => {

  }, [leftSideElement])

  return (<OurModal disableClose={disableClose}
                    parentToggle={parentToggle}
                    setParentClose={setParentClose}
    >
      <div className="modal-container paper-base" style={overrideModalStyle}>
        {disableClose && leftSideElement === undefined ? undefined :
          <div className="flex-row padding-inline-self paper-modal-nav-bar" style={overrideNavBarStyle}>
            <div className="left-text paper-modal-left-side-element" style={overrideLeftSideElementStyle}>
              {leftSideElement}
            </div>
            {disableClose ? undefined :
              <div className="paper-modal-close-icon" style={overrideCloseIconStyle}>
                <CloseTooltip title={"Close"} arrow={false} placement={"top"}>
                  <IconButton size="small"
                              onClick={setParentClose}>
                    <CloseRoundedIcon/>
                  </IconButton>
                </CloseTooltip>
              </div>}
          </div>}
        <div className="modal-base">
          {children}
        </div>
      </div>
    </OurModal>
  )

}

export default OurPaperModal;